<template>
  <div class="contbg">
    <a-card>
      <a-row>
        <a-col
          :sm="24"
          :md="12"
          :lg="8"
          :xl="7"
          :xxl="7">
          <a-form-item
            label="操作人昵称"
            :label-col="{ span: 6 }"
            :wrapper-col="{ span: 16 }"
          >
            <a-input v-model="searchObj.operatorName" placeholder="请输入" />
          </a-form-item>
        </a-col>
        <a-col
          :sm="24"
          :md="12"
          :lg="8"
          :xl="7"
          :xxl="7">
          <a-form-item
            label="操作人手机号"
            :label-col="{ span: 7 }"
            :wrapper-col="{ span: 16 }"
          >
            <a-input v-model="searchObj.phone" placeholder="请输入" />
          </a-form-item>
        </a-col>
        <a-col 
          :sm="24"
          :md="12"
          :lg="8"
          :xl="10"
          :xxl="10">
          <a-form-item label="操作时间:" :labelCol="{ span: 4 }" :wrapperCol="{ span: 20 }">
            <a-range-picker
              style="width: 80%"
              :value="searchObj.rangdate"
              @change="dateChange"
              format="YYYY-MM-DD HH:mm:ss"
              :show-time="{
                hideDisabledOptions: true
              }"/>
          </a-form-item>
        </a-col>
        <a-col
          style="padding-top: 4px;"
          :sm="24"
          :md="12"
          :lg="8"
          :xl="4"
          :xxl="4">
          <a-button @click="search()" type="primary">查询</a-button>
          <a-button class="mgl10" @click="reset()">重置</a-button>
        </a-col>
      </a-row>
    </a-card>
    <a-card class="mgt16" title="操作记录列表">
      <STable
        ref="table"
        :columns="columns"
        size="default"
        :data="getList"
        rowKey="id"
        :data-source="[]"
        :scroll="{ x: true }"
      >
      </STable>
    </a-card>
  </div>
</template>

<script>
  import STable from '@/components/Table'
  import { sysOperationLog } from '@/api/system'
  import moment from 'moment'
  export default {
    name: 'OperationLog',
    components: { STable },
    data () {
      return {
        searchObj:{
          operatorName:'',
          phone:'',
          rangdate: null,
          startTime: '',
          endTime: ''
        },
        columns:[
          {
            title: '操作人昵称',
            dataIndex: 'operatorName'
          },
          {
            title: '操作人手机号',
            dataIndex: 'phone'
          },
          {
            title: '操作菜单',
            dataIndex: 'menu'
          },
          {
            title: '操作功能',
            dataIndex: 'func'
          },
          {
            title: '操作人IP地址',
            dataIndex: 'ip'
          },
          {
            title: '操作时间',
            fixed: 'right',
            dataIndex: 'createTime'
          }
        ]
      }
    },
    methods: {
      dateChange (date, dateString) {
        this.searchObj.startTime = dateString[0]
        this.searchObj.endTime = dateString[1]
        this.searchObj.rangdate = date
      },
      moment,   
      getList (paramter) {
        var params = {
          ...this.searchObj,
          page: paramter?.pageNum || 1
        }
        // 删除存储的时间区间
        delete params.rangdate
        delete paramter?.pageNum
        console.log(params)
        return sysOperationLog(Object.assign({}, params, paramter)).then(
          res => {
            if (res.code === 1) {
              res.result.list = res.result?.list || []
              res.result.total = res.result?.page?.total || 0
              res.result.pageNum = res.result?.page?.index || 0
              return res.result
            } else {
              return {
                pageNum: 0,
                total: 0,
                list: []
              }
            }
          }
        )
      },
      reset(){
        this.searchObj = {
          operatorName:'',
          phone:'',
          rangdate:null,
          startTime: '',
          endTime: ''
        }
        this.$refs.table.refresh(true)
      },
      search(){
        this.$refs.table.refresh()
      }
    },
  }
</script>

<style lang="less" scoped>
.contbg{
  background:#edf0f3;
}
.mgl10{margin-left:10px;}
.mgt16{margin-top:16px;}
</style>
